import { Helper } from '../Helper';
export class DidReceiveAssetsHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitSysCall(node, 'System.ExecutionEngine.GetScriptContainer');
        sb.emitSysCall(node, 'Neo.Transaction.GetOutputs');
        sb.emitHelper(node, options, sb.helpers.arrSome({
            map: () => {
                sb.emitSysCall(node, 'Neo.Output.GetScriptHash');
                sb.emitSysCall(node, 'System.ExecutionEngine.GetExecutingScriptHash');
                sb.emitOp(node, 'EQUAL');
            },
        }));
        if (!optionsIn.pushValue) {
            sb.emitOp(node, 'DROP');
        }
    }
}

//# sourceMappingURL=DidReceiveAssetsHelper.js.map
